export function getServiceIdFromKey(key: string) {
  return Number(key.replace('id', ''))
}

export function getServiceKeyFromId(id: number) {
  return `id${id}`
}
